import { observer } from 'mobx-react';
import { AppraisalCommunicationStore, MyChatContainer } from '@roc/feature-communication';
import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  chatContainer: {
    flex: 1,
  },
}));

export type AppraisalChatProperties = {
  store: AppraisalCommunicationStore,
  appraisalId: number
};

export const AppraisalChat= observer(
  ({ store, appraisalId }: AppraisalChatProperties) => {
    const classes = useStyles();

    return(
      <Grid container spacing={2} alignItems="stretch" style={{ minHeight: "100%", maxHeight: "100vh", width: "100vw" }}>
        <Grid item xs={12}>
          <Box display={'flex'} height={'99%'}>
            <MyChatContainer
              id={Number(appraisalId)}
              communicationStore={store}
              allowNewConversations={false}
              allowJoinConversation={true}
              showEmailAddress={false}
              showSnippet={false}
              onConversationSelect={() => { }}
              onUserNewConversation={() => { }}
              hideSidebar={true}
              className={classes.chatContainer}
              allowManageParticipants={true}
              allowAddParticipants={true}
              allowAddInternalParticipants={true}
              allowRemoveParticipants={true}
            />
          </Box>
        </Grid>
      </Grid>
    );
  });
